export const cardImportChannelId = 'CardImportChannel'

export const cardImportChannelMethods = {
  initialized() {
    console.log('initialized card import connection')
  },

  connected(){
    console.log('[CARD IMPORT] Connected!')
  },

  received(data){
    if(data.event === 'progressStart'){
      // swap indefinite for progress
      const indefiniteProgress = document.getElementById('import-starting')
      if(indefiniteProgress) indefiniteProgress.classList.add('hidden')

      const progressBar = document.getElementById('import-working')
      if(progressBar) progressBar.classList.remove('hidden')
    }

    if(data.event === 'progressUpdate'){
      // update width of the bar
      const progressBar = document.getElementById('import-working')
      if(progressBar) progressBar.firstElementChild.style.width = `${data.info.progress_percent}%`
    }

    if(data.event == 'progressComplete'){
      // remove progress and show results
      const progressDiv = document.getElementById('sync-processing')
      if(progressDiv) progressDiv.remove()

      const resultsDiv = document.getElementById('sync-completed')
      if(resultsDiv){
        resultsDiv.querySelector('span#imported').textContent = data.info.imported_records
        resultsDiv.querySelector('span#total').textContent = data.info.total_records
        resultsDiv.classList.remove('hidden')
      }
    }

    if(data.event == 'progressError'){
      // show error message (progress will be stuck)
      const errorDiv = document.getElementById('import-error')
      if(errorDiv){
        errorDiv.querySelector('div#message').textContent = data.info.message
        errorDiv.classList.remove('hidden')
      }

      // turn progress red for added effect
      const progressBar = document.getElementById('import-working')
      if(progressBar){
        progressBar.firstElementChild.classList.remove('bg-primary')
        progressBar.firstElementChild.classList.add('bg-destructive')
      }
    }
  }
}
